import createNamespaceContext from './helper/createNamespaceContext';
export var RECENT_WORK_CONTEXT = 'RecentWorkCtx';
export var RecentWorkAnalyticsContext = createNamespaceContext(RECENT_WORK_CONTEXT, 'RecentWorkAnalyticsContext');